import React, { useState } from "react";

import { ReportsBody } from '../../components/reports/reports.body.js';

// Interface for page data
interface PageData {
	allowPurchases: boolean;
}

// Interface for component props
interface ReportsProps {
	server: string;
	pageData: PageData;
}

export default function Reports({server, pageData}: ReportsProps) {

	let [data, setData] = useState<PageData>(pageData);
	
	return (
		<div className={ "app" }>
			<ReportsBody 
				allowPurchases={data.allowPurchases}
			/>
		</div>
	);
};
